/** student/sessions — KEYS. */
export const studentSessionsKeys = {
  all: () => ['student', 'sessions'] as const,
};
